import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import Y from '../../y18n'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import * as accountActions from '../../store/accounts'
import NavigationAppShell from '../../common/navigation-app-shell'
import Styles from '../../common/styles'

const mapStateToProps = state => ({
  accounts: state.accounts,
  locales: state.locales
})

const mapDispatchToProps = dispatch => ({
  accountActions: bindActionCreators(accountActions, dispatch)
})

class ChangePasswordPage extends Component {
  state = {
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
    passwordMismatch: false,
    passwordTooShort: false,
    userId: ''
  }

  componentDidMount () {
    if (this.props.accounts.profile.userId) {
      this.setState({ userId: this.props.accounts.profile.userId })
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    this.setState({ passwordMismatch: false, passwordTooShort: false })
    if (this.state.newPassword === this.state.confirmNewPassword) {
      if (this.state.newPassword.length >= 6) {
        this.props.accountActions.changePassword(this.state.userId, this.state.oldPassword, this.state.newPassword)
        this.setState({ oldPassword: '', newPassword: '', confirmNewPassword: '', passwordMismatch: false, userId: '' })
      } else {
        this.setState({ passwordTooShort: true })
      }
    } else {
      this.setState({
        passwordMismatch: true
      })
    }
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  render () {
    const { classes, accounts } = this.props
    return (
      <NavigationAppShell
        content={
          <Paper elevation={3} square>
            {accounts.loading && <LinearProgress />}
            <div className={classes.content}>
              <div className={classes.textRow}>
                <Typography variant='title'>{Y`Change password`}</Typography>
                <Typography variant='body2' className={classes.spacer}>
                  {Y`Change the password for your account here. For security reasons you must provide your existing password`}
                </Typography>
              </div>
              <form onSubmit={e => this.handleSubmit(e)}>
                <TextField
                  className={classes.spacer}
                  label={Y`Existing password`}
                  value={this.state.oldPassword}
                  onChange={this.handleChange('oldPassword')}
                  type='password'
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  required
                  fullWidth
                />
                <TextField
                  style={{ marginTop: '20px' }}
                  label={Y`New password`}
                  value={this.state.newPassword}
                  onChange={this.handleChange('newPassword')}
                  type='password'
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  helperText={Y`The password must be atleast 6 characters long`}
                  required
                  fullWidth
                />
                <TextField
                  style={{ marginTop: '20px' }}
                  label={Y`Confirm new password`}
                  value={this.state.confirmNewPassword}
                  onChange={this.handleChange('confirmNewPassword')}
                  type='password'
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  required
                  fullWidth
                />
                {this.state.passwordMismatch &&
                  <div className={classes.textRow}>
                    <Typography variant='body2' className={classes.spacer} style={{ color: 'red' }}>
                      {Y`Passwords must match`}
                    </Typography>
                  </div>}
                {this.state.passwordTooShort &&
                  <div className={classes.textRow}>
                    <Typography variant='body2' className={classes.spacer} style={{ color: 'red' }}>
                      {Y`The password must be atleast 6 characters long`}
                    </Typography>
                  </div>}
                {accounts.error &&
                  <div className={classes.textRow}>
                    <Typography variant='body2' className={classes.spacer} style={{ color: 'red' }}>
                      {accounts.error}
                    </Typography>
                  </div>}
                <div className={classes.buttonRow}>
                  <Button
                    variant='raised'
                    color='primary'
                    disabled={
                      this.state.oldPassword === '' ||
                        this.state.newPassword === '' ||
                        this.state.confirmNewPassword === ''
                    }
                    style={{ color: '#fff' }}
                    type='submit'
                  >{Y`Save password`}</Button>
                </div>
              </form>
            </div>
          </Paper>
        }
        pageName={'Change password'}
      />
    )
  }
}

ChangePasswordPage = connect(mapStateToProps, mapDispatchToProps)(ChangePasswordPage)
export default withStyles(Styles)(ChangePasswordPage)



// WEBPACK FOOTER //
// ./src/pages/account/change-password.js